import React from "react";
import Products from "../Components/Products";

const productsPage = () => {
  return <Products />;
};

export default productsPage;
